import Vue from "vue";
import * as _ from "lodash";

export interface Rect {
    x: number;
    y: number;
    width: number;
    height: number;
}

export class Transformation implements Rect {
    x: number;
    y: number;
    width: number;
    height: number;

    constructor(t?: Partial<Transformation>) {
        this.x = t?.x ?? 0;
        this.y = t?.y ?? 0;
        this.width = t?.width ?? 0;
        this.height = t?.height ?? 0;
    }
}

let headers: any[] = [];
let component: Vue | undefined;

let value: Transformation;

 let targetHeaderElement: HTMLElement | null = null;
 let targetHeaderElementInitialWidth: number | null = null;
 let nextHeaderElement: HTMLElement | null = null;
 let nextHeaderElementInitialWidth: number | null = null;

 let startingPos: [number, number] | null = null;
 let startingTransformation: Transformation | null = null;
 let draggedTransformation: Transformation | null = null;
 let mousedragFn: ((evt: MouseEvent | TouchEvent) => void) | null = null;


 function mouseupFn(event: MouseEvent | TouchEvent){
    event.cancelBubble = true;
    event.preventDefault();
    event.stopPropagation();
    
    startingPos = null;
    draggedTransformation = startingTransformation = null;
    if (mousedragFn) {
        document.removeEventListener("mousemove", mousedragFn);
        document.removeEventListener("touchmove", mousedragFn);
      }
      if (mouseupFn) {
        document.removeEventListener("mouseup", mouseupFn);
        document.removeEventListener("touchend", mouseupFn);
      }

    // set widths on header objects - otherwise v-data-table just resets everything (and we want to persist this as user table settings)
    if (targetHeaderElement && nextHeaderElement && headers){
      const index = [...targetHeaderElement.parentNode?.children ?? []].indexOf(targetHeaderElement);
      const tmpHeaders = _.cloneDeep(headers);
      tmpHeaders.filter(x => x.active)[index].width = targetHeaderElement.style.width;
      tmpHeaders.filter(x => x.active)[index + 1].width = nextHeaderElement.style.width;

      component?.$emit("update:headers", tmpHeaders);
      //$emit("update:headers", tmpHeaders);
      //headers = _.cloneDeep(tmpHeaders);
    }

    targetHeaderElement = nextHeaderElement = null;
    targetHeaderElementInitialWidth = nextHeaderElementInitialWidth = null;
  }

function mousedown (evt: MouseEvent | TouchEvent){
    evt.cancelBubble = true;
    evt.preventDefault();
    evt.stopPropagation();

    // return if mouse event and not left click
    if(evt instanceof MouseEvent && (evt as MouseEvent).button != 0){
      return;
    }
  
    startingPos =
        evt instanceof MouseEvent
          ? [evt.x, evt.y]
          : [evt.touches[0].pageX, evt.touches[0].pageY];

    draggedTransformation = new Transformation(value ?? {});
    startingTransformation = new Transformation(value ?? {});

    targetHeaderElement = (evt.target as HTMLElement).parentElement;
    if(!targetHeaderElement){
      return;
    }
    nextHeaderElement = targetHeaderElement.nextElementSibling as HTMLElement;
    targetHeaderElementInitialWidth = targetHeaderElement.clientWidth;
    targetHeaderElement.style.minWidth = "0";
    nextHeaderElementInitialWidth = nextHeaderElement.clientWidth;
    nextHeaderElement.style.minWidth = "0";

    mousedragFn = (evt: MouseEvent | TouchEvent) => {
      evt.cancelBubble = true;
      evt.preventDefault();
      evt.stopPropagation();

      if (
        !(
          draggedTransformation &&
          startingTransformation &&
          startingPos
        )
      ) {
        return;
      }

      if (!targetHeaderElement || !targetHeaderElementInitialWidth || !nextHeaderElement || !nextHeaderElementInitialWidth){
        return;
      }

      // get target widths
      const xdiff = (evt instanceof MouseEvent ? evt.x : evt.touches[0].pageX) - startingPos[0];
      const targetWidth = targetHeaderElementInitialWidth + xdiff;
      const nextHeaderWidth = nextHeaderElementInitialWidth - xdiff;

      // set target widths
      targetHeaderElement.style.width = targetWidth + "px";
      nextHeaderElement.style.width = nextHeaderWidth + "px";

      // check if target widths are below minimum withs determined by v-data-table based on column content
      if(nextHeaderWidth < nextHeaderElement.clientWidth){
        targetHeaderElement.style.width = (targetWidth - (nextHeaderElement.clientWidth - nextHeaderWidth)) + "px";
        nextHeaderElement.style.width = nextHeaderElement.clientWidth + "px";
      }
      if(targetWidth < targetHeaderElement.clientWidth){
        targetHeaderElement.style.width = targetHeaderElement.clientWidth + "px";
        nextHeaderElement.style.width = (nextHeaderWidth - (targetHeaderElement.clientWidth - targetWidth)) + "px";
      }
    };

    if (evt instanceof MouseEvent) {
      document.addEventListener("mousemove", mousedragFn);
      document.addEventListener("mouseup", mouseupFn);
    } else {
      document.addEventListener("touchmove", mousedragFn);
      document.addEventListener("touchend", mouseupFn);
    }
  }



const directive = Vue.directive("resizable-table", {
    componentUpdated: (el, binding, vnode) => {
        // waits untill DOM update
        Vue.nextTick().then(() => {
            // appends the resize handle element to all headers except last if they don't already have it
            const columns = el.querySelectorAll("th");
            for (let i = 0; i < columns.length - 1; i++) {
                if (![...columns[i].children].some(x => x.classList.contains("resize-border"))) {
                    const elem = document.createElement("div");
                    elem.classList.add("resize-border");
                    elem.onmousedown = mousedown; //binding.value["mousedown"];
                    elem.ontouchstart = mousedown //binding.value["mousedown"];
                    elem.onclick = (evt) => { evt.cancelBubble = true; evt.preventDefault(); evt.stopPropagation(); }
                    columns[i].appendChild(elem);
                }
            }

            // bind headers and component
            headers = binding.value["headers"];
            component = vnode.context;

            // remove the resize handle from last header if it's there due to hidding columns etc.
            const resizeHandleOfLastHeader = [...columns[columns.length - 1].children].find(x => x.classList.contains("resize-border"));
            if (resizeHandleOfLastHeader) {
                columns[columns.length - 1].removeChild(resizeHandleOfLastHeader);
            }
        });
    }
});

export default directive;